export default __webpack_public_path__ + "static/media/LilNounsReadingBoneys.6cb8d984.png";